import { ReadAllResponse, uuid } from "@/interfaces";
import { InvoicesRepository } from "@/repositories/invoices.repository";
import type { ChangedInvoiceStatus, InvoiceListFilters, InvoiceListJoin, InvoiceRecord } from "@/repositories/invoice-records";

export async function fetchInvoices(
  page: number = 1,
  pageSize: number = 10,
  filters?: InvoiceListFilters,
  sortKey?: string,
  sortOrder: "asc" | "desc" = "asc"
): Promise<ReadAllResponse<InvoiceListJoin>> {
  return InvoicesRepository.list(page, pageSize, filters, sortKey, sortOrder);
}

export async function fetchInvoiceById(id: uuid): Promise<InvoiceRecord> {
  return InvoicesRepository.getById(id);
}

export async function updateInvoiceStatus(id: uuid, status: ChangedInvoiceStatus): Promise<InvoiceRecord> {
  return InvoicesRepository.updateStatus(id, status);
}

export async function bulkUpdateInvoiceStatus(ids: uuid[], status: ChangedInvoiceStatus): Promise<void> {
  return InvoicesRepository.bulkUpdateStatus(ids, status);
}

export async function emailInvoice(id: uuid, email: string): Promise<void> {
  await InvoicesRepository.email(id, email);
}
